import React, { useEffect, useState } from "react";
import "./donate.css";
import { axiosInstance } from "../../axiosConfig";
import { toast } from "react-toastify";
import { Field, Formik } from "formik";
import { SubscribeDonateValidationSchema } from "../../validation";
import Images from "../../Images";

const Donate = () => {
  const [accountDetails, setAccountDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAccountDetails();
    return () => {
      setAccountDetails([]);
    };
  }, []);

  const getAccountDetails = async () => {
    setIsLoading(true);
    axiosInstance
      .get(`/setting/detail?type=accountDetails`)
      .then((response) => {
        const responseData = response?.data?.data;
        const { status } = response?.data;
        if (status) {
          setAccountDetails(responseData);
        } else {
          setAccountDetails([]);
        }
      })
      .catch((error) => toast.error(error?.message))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const initialState = {
    name: "",
    email: "",
    message: "",
    isActive: false,
    type: "donate",
  };

  const handleSubmit = async (data, { resetForm }) => {
    axiosInstance
      .post(`/subscribe`, data)
      .then((response) => {
        const { status, message } = response?.data;
        if (status) {
          resetForm();
          toast.success(message);
        }
      })
      .catch((error) => toast.error(error?.message));
  };

  return (
    <div className="donate">
      <section className="hero-section">
        <div className="welcome-area" id="welcome"></div>
      </section>
      <div className="donate-content">
        <div className="container">
          <div className="testimonies-form-img">
            <img src={Images.DonateImg} alt="" />
          </div>
          <div className="donate-title text-center">
            <h2 className="text-transform-capitalize">donate</h2>
          </div>
          <div className="donate-sub-title text-center mt-3">
            <h6>Your partnership is important to us</h6>
          </div>
          <div className="donate-account-detail">
            {/* <div className="donate-account-detail-title">
              <h4>Account Details</h4>
            </div> */}
            <div className="donate-account-detail-content">
              {isLoading
                ? Array.from({ length: 2 }).map((_, index) => (
                    <div
                      className="donate-detail donate-account-number mt-4 skeleton-card"
                      key={index}
                    >
                      <div className="skeleton skeleton-title"></div>
                      <div className="skeleton-section">
                        <div className="skeleton skeleton-label"></div>
                        <div className="skeleton skeleton-value"></div>
                      </div>
                      <div className="skeleton-section">
                        <div className="skeleton skeleton-label"></div>
                        <div className="skeleton skeleton-value"></div>
                      </div>
                      <div className="skeleton-section">
                        <div className="skeleton skeleton-label"></div>
                        <div className="skeleton skeleton-value"></div>
                      </div>
                    </div>
                  ))
                : accountDetails?.map((item, index) => (
                    <div
                      className="donate-detail donate-account-number mt-4"
                      key={index}
                    >
                      <h4>{item.bankType}</h4>
                      <div className="donate-account-details mt-2">
                        {/* <h5>Account Number</h5> */}
                        <h6>{item?.accountNumber}</h6>
                      </div>
                      <div className="donate-account-details mt-2">
                        {/* <h5>Account name</h5> */}
                        <h6>{item?.accountName}</h6>
                      </div>
                      <div className="donate-account-details mt-2">
                        {/* <h5>Bank name</h5> */}
                        <h6>{item?.bankName}</h6>
                      </div>
                    </div>
                  ))}
            </div>

            <div className="donate-detail-form mt-5">
              <Formik
                initialValues={initialState}
                onSubmit={handleSubmit}
                validationSchema={SubscribeDonateValidationSchema}
              >
                {({ errors, touched, handleSubmit }) => {
                  return (
                    <form
                      onSubmit={handleSubmit}
                      id="contact"
                      method="post"
                      noValidate="novalidate"
                    >
                      <div className="donate-detail-form-field">
                        <div className="form-field">
                          <Field
                            name="name"
                            type="text"
                            className="form-control name-input"
                            id="name"
                            placeholder="Name"
                            required
                          />
                          {errors.name && touched.name && (
                            <label className="error" htmlFor="name">
                              {errors.name}
                            </label>
                          )}
                        </div>
                        <div className="form-field">
                          <Field
                            name="email"
                            type="email"
                            className="form-control email-input"
                            id="email"
                            placeholder="Email"
                            required
                          />
                          {errors.email && touched.email && (
                            <label className="error" htmlFor="name">
                              {errors.email}
                            </label>
                          )}
                        </div>

                        <div className="checkbox-field checkbox-wrapper-33">
                          <label className="checkbox">
                            <Field
                              type="checkbox"
                              name="isActive"
                              className="me-1 checkbox__trigger visuallyhidden"
                            />
                            <span className="checkbox__symbol">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                version="1"
                                viewBox="0 0 28 28"
                                height="28px"
                                width="28px"
                                className="icon-checkbox"
                                aria-hidden="true"
                              >
                                <path d="M4 14l8 7L24 7"></path>
                              </svg>
                            </span>
                          </label>

                          <span className="checkbox__textwrapper">
                            We would love to say thank you.
                          </span>
                        </div>
                      </div>

                      <div className="donate-detail-form-btn">
                        <button
                          type="submit"
                          id="form-submit"
                          className="main-button"
                        >
                          Send
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Donate;

// <h6>We would love to say thank you.</h6>
